import { Component, OnInit, AfterContentInit } from '@angular/core';
import { AuthService } from '../../app/auth.service';
import { BaseLoginComponent } from './base-login.component';
import { AppState } from '../store/AppState';
import { Store } from '@ngrx/store';
import { ServiceLocator } from '../ServiceLocator';
import { AppConfiguration } from '../conf/app.configuration';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { clearModalsOnCloseSession } from '../app.helpers';
import { ActivatedRoute } from '@angular/router';
import { BackGroundService } from './background.service';
import { SET_ACCESSMODE } from '../store/user';
import { UIService } from '../ui.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'login',
  templateUrl: 'login-view.template.html'
})
export class LoginViewComponent extends BaseLoginComponent implements OnInit, AfterContentInit {
  background: any;

  private store: Store<AppState>;

  public name: string;
  public pass: string;
  public code: string;

  modoMesaEnabled = false;
  modoAcceso = false;
  resetPassword = false;

  errorMsg = '';
  public show_spin = -100;

  constructor(authService: AuthService,
    public appConfig: AppConfiguration,
    public uiService: UIService,
    private waitService: WaitLoadingService,
    private route: ActivatedRoute,
    private backGroundService: BackGroundService,
    private translate: TranslateService,) {
    super(authService);
    this.store = ServiceLocator.injector.get(Store) as Store<AppState>;
    this.modoMesaEnabled = appConfig.getValue('modo.mesa.enabled');
    this.resetPassword = appConfig.getValue('login.resetPassword');
  }

  ngOnInit(): void {
    // al inicializar el componte se genera el background
    this.background = this.calculateBackground();
    clearModalsOnCloseSession();

    this.route.queryParams.subscribe(params => {
      this.errorMsg = params['errorMsg'];
      if (params['newpassword']) {
        this.errorMsg = this.translate.instant('LoginView.change.success');
      }
    });
  }

  onSubmit() {
    if (!this.name || !this.pass) {
      this.errorMsg = 'Debe introducir el usuario y la contraseña de acceso';
    } else {
      this.show_spin = 100;
      this.subscribe(this.authService.basicLogin(this.name, this.pass, this.code),
        () => {
          this.errorMsg = '';
          // IMPORTANTE: Si el login es correcto, establecer en sesión el modo de acceso
          let thisModoAcceso = this.modoAcceso;
          this.store.dispatch(SET_ACCESSMODE({ modoAcceso: thisModoAcceso }));
          if (this.appConfig.getValue('ENS.showLoginAlert')) {
            // mostrar alerta ENS
            this.uiService.showENSAlertMessage(false);
          }
        },
        error => {
          this.show_spin = -100;
          this.errorMsg = this.getErrorResponse(
            error,
            'Usuario/contraseña incorrectos.'
          );
        }
      );
    }
  }

  ngAfterContentInit(): void {

    this.waitService.cancelWaiting();
  }

  public calculateBackground() {
    return this.backGroundService.calculateBackground();
  }
}
